export default __webpack_public_path__ + "static/media/logo.37194b04.svg";